import { Typography } from '@eventbrite/marmalade';
import React from 'react';
import { useTicketContext } from './context';
import styles from './TicketCard.module.scss';

export const TicketCosts: React.FC = () => {
    const { price, fee, tax } = useTicketContext();

    return (
        <div className={styles.pricing}>
            <div>
                <Typography as={'span'} variant="body-md-bold" color="ui-800">
                    {price}
                </Typography>
            </div>
            <div>
                {fee && (
                    <div>
                        <Typography
                            as={'span'}
                            variant="body-sm"
                            color="neutral-500"
                        >
                            {fee}
                        </Typography>
                    </div>
                )}
                {tax && (
                    <div>
                        <Typography
                            as={'span'}
                            variant="body-sm"
                            color="neutral-500"
                        >
                            {tax}
                        </Typography>
                    </div>
                )}
            </div>
        </div>
    );
};
